export default {"src":"/frontend-static/_next/static/media/paypalLight.448c529a.svg","height":60,"width":100,"blurWidth":0,"blurHeight":0};